import React from 'react';
import PropTypes from 'prop-types';
import {find, isEmpty} from 'lodash';
import ScheduleVisitButton from '../schedule-visit-button';
import Card from 'src/components/Cards/Card';
import {withCommas} from 'shared/utils';

export default class ScheduleVisitCard extends React.Component {
  static propTypes = {
    nickname: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    partnerScholarships: PropTypes.array.isRequired,
  };

  componentDidMount() {
    const {slug} = this.props;
    const universitiesWithMobiVisitDays = {
      'florida-international-university': 'fiu',
      'mcmurry-university': 'mcm',
      'gannon-university': 'gannon',
    };

    this.script = document.createElement('script');
    this.script.src = 'https://mobi.visitdays.com/assets/snippet/assets/main.bundle.js';
    this.script.setAttribute('data-mobi-subdomain', universitiesWithMobiVisitDays[slug]);
    this.script.setAttribute('data-mobi-hide-default-button', true);
    this.script.async = true;
    this.script.defer = true;

    document.body.appendChild(this.script);
  }

  componentWillUnmount() {
    document.body.removeChild(this.script);
  }

  render() {
    const {nickname, partnerScholarships} = this.props;

    if (isEmpty(partnerScholarships)) return null;

    const visitScholarship = find(partnerScholarships, {title: 'Visit our Campus'});

    if (!visitScholarship) return null;

    return (
      <Card>
        <div className="college-profile-schedule-visit-card">
          <header className="college-profile-schedule-visit-card-header">
            {nickname} is ready for your visit!
            <ScheduleVisitButton
              name="college-profile-fiu-mobi-right-rail"
              className="right-rail-desktop"
            />
          </header>
          Schedule a trip to campus today and earn a ${withCommas(visitScholarship.amount)}{' '}
          micro-scholarship for visiting.
          <ScheduleVisitButton
            name="college-profile-fiu-mobi-right-rail"
            className="right-rail-mobile"
          />
        </div>
      </Card>
    );
  }
}
